import React from 'react';
import { useTranslation } from 'next-i18next';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '../atoms/Button';
import Logo from '../atoms/Logo';
import Checkbox from '../atoms/Checkbox';
import { packages } from '../../data/packages';
// import { styles } from '../../data/packages';

interface UpgradeHelperProps {
  h: string;
  p: string;
  setLayer: (el: any) => void;
}

const UpgradeHelper = ({ h, p, setLayer }: UpgradeHelperProps) => {
  const { t } = useTranslation(['common']);

  return (
    <>
      <Container>
        <Row className="justify-content-center">
          <Col xs={6} md={4} lg={2}>
            <Logo noLink large center />
          </Col>
        </Row>
        <Row>
          <Col>
            <h2>{h}</h2>
            <p>{p}</p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col xs={6} md={4} lg={3}>
            <br />
            <br />
            <Button
              dark
              large
              full
              label={t('common:cta-continue')}
              onClick={() => setLayer({})}
            />
            <br />
            <br />

            <Checkbox
              name="showOnce"
              label={t('common:show-once')}
              onChange={(obj) => {
                obj.showOnce
                  ? localStorage.setItem('vs-upgrade-helper', 'seen')
                  : localStorage.removeItem('vs-upgrade-helper');
              }}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UpgradeHelper;
